import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExpressService } from '../services/express.service';

@Component({
  selector: 'app-express-list',
  templateUrl: './express-list.component.html',
  styleUrls: ['./express-list.component.scss']
})
export class ExpressListComponent implements OnInit {
  public accessRoles: any;
  public scrollDistance = 2;
  public throttle = 10;
  public searchValue = "";





  constructor(
    private router: Router,
    public expressService: ExpressService
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.expressService.headerSearchEventEmitter.subscribe((searchTerm: string) => {
      this.onSearchChange(searchTerm);
    });
  }

  ngOnInit(): void {
    this.expressService.isSearchShow = true;
    this.expressService.getListData();
  }

  onSearchChange(str){
    this.searchValue = str;
    if(this.searchValue.length > 1){
      let query = {};
      query['search'] = this.searchValue;
      query['page'] = 1;
      this.expressService.expressListData = [];
      this.expressService.getListData(query);
    }else{
      this.expressService.getListData({page:1});
    }
  }

  createRequest(){
    this.expressService.backTrack = "express-list";
    this.router.navigate(['/express/request']);
  }

  getDynamicStyleHeader(){
    return this.expressService.expressListHeader.map(() => '1fr').join(' ') + ' 1fr';
  }

  onScroll(){
    if( this.expressService.listPage == 1 || this.expressService.listPage < this.expressService.listTotalPage){
      this.expressService.listPage++;
      let query = {};
      if (this.searchValue && this.searchValue != "") {
        query['search'] = this.searchValue;
      }
      query['page'] = this.expressService.listPage;
      this.expressService.getListData(query);
    }
  }

  viewDetails(uuid){
    this.expressService.expressSaveId = uuid;
    this.expressService.backTrack = "express-list";
    this.router.navigate(['/express/details/'+uuid]);
  }

}
